import {useEffect, useState} from 'react';

import {fetchUserCoupons} from '~/shared/services/bffService/api';
import {FetchUserCouponsResponse} from '~/shared/services/bffService/api/interfaces/responses';
import {is401Error} from '~/shared/services/apiErrorService';
import {handleRefreshToken} from '~/shared/services/auth';

const useMyBenefits = () => {
  const [coupons, setCoupons] = useState<FetchUserCouponsResponse>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const fetchUserCouponsHandler = async (): Promise<void> => {
      try {
        const data = await fetchUserCoupons();
        setCoupons(data);
        setIsLoaded(true);
      } catch (error) {
        if (is401Error(error)) {
          return handleRefreshToken(error, fetchUserCouponsHandler);
        }
        setIsLoaded(true);
      }
    };

    fetchUserCouponsHandler();
  }, []);

  return {
    coupons,
    isLoaded,
  };
};

export default useMyBenefits;
